//var CRcarrierServiceEnabled = true;

document.addEventListener("DOMContentLoaded", function () {
  // setTimeout(() => {
  //   const input = document.getElementById("pickup-information");
  //   const input2 = document.getElementById("pickup-selected-store");
  //   const input3 = document.getElementById("pickup-selected-store-id")
  //   const input4 = document.getElementById("pickup-unixtimestamp")
    
        
  //   if (input) {
  //     input.value = "";
  //     input2.value = "";
  //     input3.value = "";
  //     input4.value = "";
  //   }  
  // }, 1500);
  
});

function removePickupParams (){
  var attributes = {};
  attributes['Pickup_Information'] = '';
  attributes['Pickup_StoreID'] = '';
  attributes['_unixTimestamp'] = '';
  attributes['_formattedDate'] = '';

  attributes['Pickup_date'] = '';
  attributes['Pickup_time']  = '';
  attributes['Pickup_name']  = '';
  attributes['Pickup_phone']  = '';
  attributes['Pickup_extra1']  = '';
  attributes['Pickup_extra2']  = '';
  attributes['Pickup_extra3']  = '';
  attributes['Pickup_Store']  = '';
  attributes['pickup']  = '';

  console.log('Remove previous params')
  storePickup.updateCartAttributes(attributes)  

  const input = document.getElementById("pickup-information");
  const input2 = document.getElementById("pickup-selected-store");
  const input3 = document.getElementById("pickup-selected-store-id")
  const input4 = document.getElementById("pickup-unixtimestamp")
  
  
  console.log('---->', input.value)
  if (input) {
    input.value = "";
    input2.value = "";
    input3.value = "";
    input4.value = "";
  }  
}

document.addEventListener('crButtonsLoaded', function (e) {
  //removePickupParams()

  // jqCR('.cr-shipping-method').on('click', function(){
  //   removePickupParams()
  // })
})

document.addEventListener('crPickupActivated', function (e) {
  cartForm = document.querySelector('#cart');
  //if (!cartForm) return;

  let isHandling = false;

  cartForm.addEventListener('submit', async (e) => {
    // Only intercept when the submit is for checkout
    const submitter = e.submitter; // modern browsers
    const isCheckout =
      (submitter && (submitter.name === 'checkout' || submitter.value === 'checkout')) ||
      // fallback if we can't detect submitter reliably
      true;
    console.log(submitter.name)
    if (!isCheckout) return;
    if (isHandling) return;

    e.preventDefault();
    isHandling = true;

    try {
      const cart = await storePickup.getCartItems();
      console.log(cart);

      // If your addLineProperty expects a cart + value:
      await storePickup.addLineProperty(cart, 'pickup');

      // Submit the cart form after your async call is done
      //cartForm.submit();
    } catch (err) {
      console.error('Failed to set line property before checkout:', err);

      // Decide what to do on failure:
      // 1) allow checkout anyway:
      //cartForm.submit();
      // 2) or block and show a message instead (replace with your UI)
      // alert('Please try again. Could not update cart.');
    } finally {
      isHandling = false;
    }
  });
})
